"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_EVENT = void 0;
var GET_EVENT = exports.GET_EVENT = 'GET_EVENT';